<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Ubicaciones PBE por Zona</p>
    </header>
    <div class="modal-card-body">
      <section>
        <div v-if="isLoading" class="notification">
          <b-loading
            :active="isLoading"
            :is-full-page="false"
            :can-cancel="false"
          />
        </div>
        <div v-else class="tree-view-node">
          <tree-view-item
            v-for="item in options"
            :key="`option-item-${item.id}`"
            :item="item"
            @check="checkOptionHandle"
            @open="openNodeHandle"
          />
        </div>
      </section>
    </div>
    <footer class="modal-card-foot">
      <div class="buttons">
        <b-button type="is-info" @click="guardarUbicaciones">
          <span>Guardar</span>
        </b-button>
        <button class="button" @click="cerrarForm">
          <span>Salir</span>
        </button>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import TreeViewItem from '@/components/treeView/TreeViewItem.vue'
import { ubicacionService, zonaService } from '@/services'

export default {
  name: 'Ubicaciones',
  components: {
    TreeViewItem
  },
  props: {
    zona: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      options: []
    }
  },
  computed: {
    ...mapGetters('monitor', ['bodega', 'pedidos', 'sucursal'])
  },
  created() {
    this.cargarZonas()
  },
  methods: {
    _flatObject(items, level = 0) {
      const result = []
      items
        .filter((item) => item.selected)
        .forEach((item) => {
          const object = {}
          switch (level) {
            case 0:
              object.zonaPBE = item.id
              break
            case 1:
              object.pasilloPBE = item.id
              break
            case 2:
              object.nivelPBE = item.id
              break
            case 3:
              object.ubicacionPBE = item.id
              break
          }
          if (item.children && item.children.length > 0) {
            var innerItems = this._flatObject(item.children, level + 1)
            innerItems.forEach((itm) =>
              result.push(Object.assign({}, object, itm))
            )
          } else {
            result.push(object)
          }
        })
      return result
    },
    _checkOptionTree(items, selected) {
      const index = items.findIndex((obj) => obj.id === selected.id)
      // Si no se encuentra item, se retorna.
      if (index === -1) return items
      // Si se marcó opción, se cambia selected.
      if (selected.selected) {
        items[index].selected = selected.selected
      } else {
        if (items[index].children && items[index].children.length > 0) {
          if (items[index].children.every((obj) => !obj.selected)) {
            items[index].selected = selected.selected
          }
        } else items[index].selected = selected.selected
      }
      // Si hay más niveles, se hace llamada recursiva.
      if (selected.children) {
        items[index].children = this._checkOptionTree(
          items[index].children,
          selected.children
        )
      } else {
        if (!items[index].modified) items[index].modified = true
        if (items[index].children)
          items[index].children = this._checkAllChildren(
            items[index].children,
            items[index].selected
          )
      }
      return items
    },
    _checkAllChildren(items, value) {
      items.forEach((item, index) => {
        items[index].selected = value
        if (!items[index].modified) items[index].modified = true
        if (items[index].children) {
          this._checkAllChildren(items[index].children, value)
        }
      })
      return items
    },
    _processData(node, items) {
      if (!node.modified) return items
      return this._checkAllChildren(items, node.selected)
    },
    _loadNodechildren(items, payload, parents = []) {
      const index = items.findIndex((obj) => obj.id === payload.id)
      // Si no existe el objeto a cargar, se retorna.
      if (index === -1) return items
      // Si nivel tiene hijo, se llama recursivamente
      if (payload.children) {
        items[index].children = this._loadNodechildren(
          items[index].children,
          payload.children,
          [...parents, { level: payload.level, id: payload.id }]
        )
      } else {
        // Si los nodos hijos están cargados, se retorna.
        if (items[index].children && items[index].children.length > 0)
          return items
        switch (payload.level) {
          case 0:
            ubicacionService
              .getPasillos(this.bodega.id, this.zona.id, payload.id)
              .then(
                (rs) =>
                  (items[index].children = this._processData(
                    items[index],
                    rs.data
                  ))
              )
              .catch((error) => this.procesarError(error))
              .then(() => (this.isLoading = false))
            break
          case 1:
            ubicacionService
              .getNiveles(this.zona.id, payload.id)
              .then(
                (rs) =>
                  (items[index].children = this._processData(
                    items[index],
                    rs.data
                  ))
              )
              .catch((error) => this.procesarError(error))
              .then(() => (this.isLoading = false))
            break
          case 2: {
            const zonaPBEId = parents.find((item) => item.level === 0).id
            const pasilloPBEId = parents.find((item) => item.level === 1).id
            ubicacionService
              .getUbicaciones(
                this.bodega.id,
                this.zona.id,
                zonaPBEId,
                pasilloPBEId,
                payload.id
              )
              .then(
                (rs) =>
                  (items[index].children = this._processData(
                    items[index],
                    rs.data
                  ))
              )
              .catch((error) => this.procesarError(error))
              .then(() => (this.isLoading = false))
            break
          }
        }
      }
      return items
    },
    cerrarForm(event, update = false) {
      this.$emit('close', { zonaId: this.zona.id, update })
    },
    checkOptionHandle(payload) {
      this.options = this._checkOptionTree(this.options, payload)
    },
    openNodeHandle(payload) {
      this.options = this._loadNodechildren(this.options, payload)
    },
    cargarZonas() {
      this.isLoading = true
      ubicacionService
        .getZonas(this.zona.id)
        .then((rs) => {
          this.options = rs.data
        })
        .catch((error) => this.procesarError(error))
        .then(() => (this.isLoading = false))
    },
    guardarUbicaciones() {
      this.isLoading = true
      const ubicaciones = this._flatObject(this.options)
      zonaService
        .addUbicaciones(this.zona.id, ubicaciones)
        .then((rs) => {
          this.notificarAccionCompletada(
            'Se configuraron las ubicaciones para la zona correctamente'
          )
          this.cerrarForm(null, true)
        })
        .catch((error) => this.procesarError(error))
        .then(() => (this.isLoading = false))
    }
  }
}
</script>
